import copy from "../../../copy/en/admin-workspace.json" with { type: "json" };

export const ADMIN_PATH = "/admin";
export const USERS_PATH = `${ADMIN_PATH}/users`;
export const SALES_ROLES_PATH = `${ADMIN_PATH}/sales-roles`;
export const ORG_IMPORT_PATH = `${ADMIN_PATH}/org-import`;
export const STYLEGUIDE_PATH = `${ADMIN_PATH}/styleguide`;
export const CUSTOM_FIELDS_PATH = `${ADMIN_PATH}/custom-fields`;
export const PRACTICE_LINKAGE_PATH = `${ADMIN_PATH}/practice-linkage`;
export const REP_APPLICATIONS_PATH = `${ADMIN_PATH}/rep-applications`;
export const EMAIL_ACTIVITY_PATH = `${ADMIN_PATH}/email-activity`;
export const ZOOM_ATTRIBUTION_PATH = `${ADMIN_PATH}/zoom-attribution`;

export function adminEmailView(params: URLSearchParams): "history" | "summaries" {
  // Contextual email links always select their exact record history.
  return !params.has("subjectType") && !params.has("subjectId")
    && params.getAll("view").length === 1 && params.get("view") === "summaries"
    ? "summaries" : "history";
}

export interface AdminSection { to: string; label: string }
export interface AdminGroup { id: string; label: string; sections: AdminSection[] }

export function adminGroups({ canManage, canOrg, canZoom }: { canManage: boolean; canOrg: boolean; canZoom: boolean }): AdminGroup[] {
  if (!canManage) return [];
  return [
    { id: "people", label: copy.people, sections: [
      { to: USERS_PATH, label: copy.accounts },
      { to: REP_APPLICATIONS_PATH, label: copy.applications },
    ] },
    { id: "email", label: copy.email, sections: [
      { to: EMAIL_ACTIVITY_PATH, label: copy.history },
      { to: `${EMAIL_ACTIVITY_PATH}?view=summaries`, label: copy.summaries },
    ] },
    { id: "configuration", label: copy.configuration, sections: [
      ...(canOrg ? [{ to: SALES_ROLES_PATH, label: copy.roles }] : []),
      { to: CUSTOM_FIELDS_PATH, label: copy.fields },
    ] },
    { id: "advanced", label: copy.advanced, sections: [
      ...(canZoom ? [{ to: ZOOM_ATTRIBUTION_PATH, label: copy.zoom }] : []),
      { to: PRACTICE_LINKAGE_PATH, label: copy.linkage },
      ...(canOrg ? [{ to: ORG_IMPORT_PATH, label: copy.import }] : []),
      { to: STYLEGUIDE_PATH, label: copy.reference },
    ] },
  ];
}

export function adminSectionActive(section: AdminSection, pathname: string, search: string): boolean {
  const [path, query = ""] = section.to.split("?");
  if (pathname !== path) return false;
  return path !== EMAIL_ACTIVITY_PATH
    || adminEmailView(new URLSearchParams(search)) === adminEmailView(new URLSearchParams(query));
}
